<div class="report-parameters-dialog">
  <div class="parameters-card">
    <div class="grid grid-cols-1 gap-x-8 gap-y-4 md:grid-cols-3">
      <div class="parameter col-span-1 md:col-span-3">
        <div class="parameter-label">Nazwa</div>
        <div class="parameter-value">
          {{ report().nazwa.label | enumLabel: reportName }}
        </div>
      </div>

      @if (isBaseReport()) {
        <div class="parameter">
          <div class="parameter-label">Data od</div>
          <div class="parameter-value">
            {{ dataOdLabel() }}
          </div>
        </div>
        <div class="parameter">
          <div class="parameter-label">Data do</div>
          <div class="parameter-value">
            {{ dataDoLabel() }}
          </div>
        </div>
      }

      @if (isComparisonReport()) {
        <div class="parameter">
          <div class="parameter-label">Cykl porównawczy</div>
          <div class="parameter-value">
            {{ report().cykl?.label | emptyFallback }}
          </div>
        </div>
        <div class="parameter">
          <div class="parameter-label">Rok</div>
          <div class="parameter-value">{{ report().rok | emptyFallback }}</div>
        </div>
        <div class="parameter">
          <div class="parameter-label">Do roku</div>
          <div class="parameter-value">
            {{ report().doRoku | emptyFallback }}
          </div>
        </div>
      }

      @if (isComparisonReport() && isHalfYearCycle()) {
        <div class="parameter">
          <div class="parameter-label">Półrocze</div>
          <div class="parameter-value">
            {{ report().polrocze | emptyFallback }}
          </div>
        </div>
        <div class="parameter">
          <div class="parameter-label">Do półrocza</div>
          <div class="parameter-value">
            {{ report().doPolrocza | emptyFallback }}
          </div>
        </div>
      }

      @if (isComparisonReport() && isQuarterCycle()) {
        <div class="parameter">
          <div class="parameter-label">Kwartał</div>
          <div class="parameter-value">
            {{ report().kwartal | emptyFallback }}
          </div>
        </div>
        <div class="parameter">
          <div class="parameter-label">Do kwartału</div>
          <div class="parameter-value">
            {{ report().doKwartalu | emptyFallback }}
          </div>
        </div>
      }

      @if (isComparisonReport() && isMonthCycle()) {
        <div class="parameter">
          <div class="parameter-label">Miesiąc</div>
          <div class="parameter-value">
            {{ report().miesiac | emptyFallback }}
          </div>
        </div>
        <div class="parameter">
          <div class="parameter-label">Do miesiąca</div>
          <div class="parameter-value">
            {{ report().doMiesiac | emptyFallback }}
          </div>
        </div>
      }

      <div
        class="col-span-1 grid grid-cols-1 gap-x-8 gap-y-4 md:col-span-3 md:grid-cols-3 md:gap-y-0"
      >
        <div class="parameter">
          <div class="parameter-label">Nazwa wniosku</div>
          <div class="parameter-value">
            @for (
              item of applicationTypeCodes();
              let idx = $index;
              track $index
            ) {
              <span class="status-badge mr-1 mt-1">
                {{ item | applicationTypeLabel: applicationTypeOptions() }}
              </span>
            }
          </div>
        </div>

        <div class="parameter">
          <div class="parameter-label">Status wniosku</div>
          <div class="parameter-value">
            @for (item of statusCodes(); let idx = $index; track $index) {
              <span class="status-badge mr-1 mt-1">
                {{ item | statusLabel }}
              </span>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flex justify-end mt-6">
    <p-button
      type="button"
      label="Zamknij"
      styleClass="customInfoButton outlined"
      (click)="closeDialog()"
    />
  </div>
</div>
